module.exports = "<app-img-header imgUrl=\"/assets/images/img-headers/tavern.jpg\"></app-img-header>\r\n<div class=\"tavern-container\">\r\n  <div class=\"container\">\r\n    <h1 translate>TAVERN.TITLE</h1>\r\n    <p translate [innerHTML] = \"'TAVERN.GALLERY-TEXT' | translate\"></p><br/>\r\n\r\n    <gallery [galleryName]=\"galleryName\">\r\n    </gallery>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/tavern/tavern.component.html
// module id = 789
// module chunks = 1